import { lazy } from 'react';

const KycRenewalData = lazy(() => import('./KycRenewalData'));

export { KycRenewalData };

